import { Box, Card, CircularProgress, Container, Typography } from '@mui/material';
import { m } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';
import { isMobileSafari, isOpera, isSafari } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import { toast } from 'react-toastify';
import Iconify from 'src/components/Iconify';
import { MotionViewport, varFade } from 'src/components/animate';
import { HOST_API } from "src/config";
import useAuth from "src/hooks/useAuth";
import navCarrouselButton from "src/layouts/dashboard/navbar/navCarrouselButton";
import IPlan from "src/pages/dashboard/@types";
import axiosInstance from "src/utils/axios";

export function CarrouselButtons() {
  const carouselRef = useRef<Slider>(null);
  const { user, selectedContract, contracts } = useAuth();

  const [hasOnlyJazigo, setHasOnlyJazigo] = useState(false);
  const [loadingButtonBenefits, setLoadingButtonBenefits] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    setHasOnlyJazigo(contracts.filter((r: IPlan) => r.type_contract !== "C").length === 0);
  }, []);

  const settings = {
    arrows: true,
    slidesToShow: 7,
    infinite: false,
    responsive: [
      {
        breakpoint: 1279,
        settings: { slidesToShow: 7 },
      },
      {
        breakpoint: 959,
        settings: { slidesToShow: 5 },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 4 },
      },
      {
        breakpoint: 460,
        settings: { slidesToShow: 3 },
      },
    ],
  };

  async function openBenefits() {
    setLoadingButtonBenefits(true);
    try {
      const response = await axiosInstance.get(`/benefits/auth`);
      const link = response.data.redirect;

      if (isSafari || isMobileSafari || isOpera) {
        window.location.assign(link);
      } else {
        window.open(link, "_blank");
      }

      setLoadingButtonBenefits(false);
    } catch (error) {
      console.error(error);
      toast.error(`${error.message}`, {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
      });
      setLoadingButtonBenefits(false);
    }
  }

  function navigateTo(path: string) {
    navigate(path);
  }

  return (
    <Container component={MotionViewport} sx={{ pb: 10, textAlign: "left", px: 0, py: 0.5 }}>
      <Box sx={{ position: "relative" }}>
        <Slider ref={carouselRef} {...settings}>
          <Box component={m.div} variants={varFade().in} sx={{ py: 0, mx: "1px" }}>
            <Card
              sx={{
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: "100px",
                height: "100px",
                borderRadius: "1rem",
                backgroundColor: "#EA9000",
              }}
              onClick={() => openBenefits()}
            >
              {loadingButtonBenefits && <CircularProgress size={14} />}
              {!loadingButtonBenefits && (
                <>
                  <Box
                    component="span"
                    sx={{
                      width: 24,
                      height: 24,
                      color: "white",
                      display: "inline-block",
                    }}
                  >
                    <Iconify icon="bxs:shopping-bags" fontSize={25} />
                  </Box>
                  <Typography sx={{ fontSize: "12px", textAlign: "center", color: "white" }}>
                    Sempre + Benefícios
                  </Typography>
                </>
              )}
            </Card>
          </Box>
          {navCarrouselButton(selectedContract?.role, hasOnlyJazigo).length > 0 &&
            navCarrouselButton(selectedContract?.role, hasOnlyJazigo)[0].items.map((item: any) => (
              <Box
                key={item.title}
                component={m.div}
                variants={varFade().in}
                sx={{ py: 0.5, mx: "5px" }}
              >
                <Card
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100px",
                    padding: item.title === "Onde Estamos" ? "15px" : 0,
                    height: "100px",
                    borderRadius: "1rem",
                    cursor: "pointer",
                  }}
                  onClick={() => navigateTo(item.path)}
                >
                  <Box
                    component="span"
                    sx={{
                      width: 24,
                      height: 24,
                      color: "#7DAFE8",
                      display: "inline-block",
                    }}
                  >
                    {item.icon}
                  </Box>
                  <Typography sx={{ fontSize: "12px", textAlign: "center" }}>
                    {item.title}
                  </Typography>
                </Card>
              </Box>
            ))}
        </Slider>
      </Box>
    </Container>
  );


}